import { render, staticRenderFns } from "./post_grid_item.vue?vue&type=template&id=aaf17dee&scoped=true"
import script from "./post_grid_item.vue?vue&type=script&lang=ts"
export * from "./post_grid_item.vue?vue&type=script&lang=ts"
import style0 from "./post_grid_item.vue?vue&type=style&index=0&id=aaf17dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf17dee",
  null
  
)

export default component.exports